<div class="card card-box mb-5 p-3 text-center">
    <div class="my-3">
        <h6 class="font-weight-bold font-size-lg mb-1 text-black">Revenue progress</h6>
        <p class="text-black-50 mb-0">Our company revenues, split by progress.</p>
    </div>
    <div class="d-flex flex-row flex-wrap justify-content-center">
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar1.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Marion Devine
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>4.8</span>
                <span class="px-1">|</span>
                34 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar2.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Monique Hanna
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>5.0</span>
                <span class="px-1">|</span>
                81 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar3.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Celine Goulding
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>2.9</span>
                <span class="px-1">|</span>
                52 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar4.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Anabel Mayo
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>4.6</span>
                <span class="px-1">|</span>
                76 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar5.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Rueben Hays
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>4.8</span>
                <span class="px-1">|</span>
                76 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="divider-v divider-v-lg"></div>
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar6.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Kush Malone
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>3.5</span>
                <span class="px-1">|</span>
                34 Jobs
            </div>
        </div>
        <div class="position-relative px-5 py-3">
            <div class="avatar-icon-wrapper rounded-circle d-80 mx-auto">
                <div class="d-block p-0 avatar-icon-wrapper rounded-circle m-0">
                    <div class="rounded-circle overflow-hidden">
                        <img alt="..." class="img-fluid" src="assets/images/avatars/avatar7.jpg"/>
                    </div>
                </div>
            </div>
            <div class="font-weight-bold mt-1">
                Haydn Porter
            </div>
            <div class="font-weight-bold font-size-sm text-black-50">
                <fa-icon [icon]="['fas', 'star']" class="text-warning mr-1"></fa-icon>
                <span>4.5</span>
                <span class="px-1">|</span>
                23 Jobs
            </div>
        </div>
    </div>
</div>
